const BoxContainer = (props) => {
  return (
    <div className="flex flex-col gap-2 my-4 overflow-hidden hover:overflow-y-auto">
      {props.children}
    </div>
  );
};

export default BoxContainer;
